import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Constants } from 'src/app/config/app.config';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  private mutations: any
  private chatWidgetLoaded = new BehaviorSubject<boolean>(false);
  public chatWidgetLoaded$ = this.chatWidgetLoaded.asObservable();
  public chatButtonClick = new Subject<boolean>();
  private chatWidget: any;

    constructor(@Inject(DOCUMENT) private dom: Document, private constants: Constants, private commonService: CommonService) {
      this.chatButtonClick.subscribe(data => {
        try {
          const chatButton =  this.dom.getElementsByClassName('mtx-genesys-launcher-button').item(0) as HTMLElement;
          chatButton.click();
        } catch (error) {
          console.error('Error clicking chat button:', error);
        }
      })

      if(this.commonService.isPlatformBrowser()) {
        this.createMutationObserver();
      }
      
    }

    /**
     * To add the canonical url to the dom
     * @param url canonical url from CMS
     */
    addGenesysChatWidget() {
      const script: HTMLScriptElement = this.dom.createElement('script');
      script.setAttribute('id', 'widgets');
      script.setAttribute('src', this.constants.GenesysCdnUrl);
      script.setAttribute('onload', `javascript:window.StartGenesys({attributes:{'Source':'UMass','WebsiteUrl':window.location.href,'Environment':'${this.constants.GenesysEnvironment}'},debug:false});`);
      this.dom.body.appendChild(script);
    }

    /**
     * Creates a mutation observer and listens for chat widget load
     */
    createMutationObserver() {
      this.mutations = new MutationObserver((mutations: MutationRecord[]) => {
        mutations.forEach((mutation: MutationRecord) => {
          if (mutation.type === "childList" && mutation.addedNodes?.length>0) {
            mutation.addedNodes.forEach((node: any) => {
              if(node.className?.includes('mtx-genesys-launcher-button') || node.id?.includes('mtx-genesys-launcher-launcherbutton')) {
                if(window._genesys) {
                  this.chatWidget = window._genesys.widgets.bus.registerPlugin('ChatPlugin');
                }
                // Trigger the event so that the other chat buttons (in header or in content) can be displayed. 
                this.chatWidgetLoaded.next(true);
                // Stops listening for mutation events.
                this.mutations.disconnect();
              }
            })
          }
        });
      });

      // Starts listening to the mutation created above.
      this.mutations.observe(this.dom.body, {
        childList: true,
        characterData: true
      });
    }

    /**
     * To show or hide the chat widget
     * @param command widget command
     */
    showOrHideChat(command: 'hideChatButton' | 'showChatButton') {
      if(this.chatWidget) {
        this.chatWidget.command('WebChat.' + command);
        this.handleChatButtonVisibility(command);
      } else {
        const chatLoaded: any = this.chatWidgetLoaded$.subscribe(data=> {
          if (data) {
            setTimeout(()=> {
              this.handleChatButtonVisibility(command);
              this.chatWidget.command('WebChat.' + command).done(function(e: any) {
                chatLoaded.unsubscribe();              
              }).fail(function(e: any){
                console.warn("failed to" + command , e);
              });
            }, 10);
          }
        });
      }
    }

    handleChatButtonVisibility(command: 'hideChatButton' | 'showChatButton') {
      const elements = [
        this.dom.querySelector('#mtx-genesys-launcher-launcherbutton'),
        this.dom.querySelector('#mtx-genesys-launcher-autoinvite')
      ];

      elements.forEach(el => {
        if (!el) return;
        el.classList.toggle('hideChatButton', command === 'hideChatButton');
      });
    }
}

declare global {
  interface Window {
    _genesys: any;
  }
}